import type { TFunction } from "i18next";

import type { User } from "@/pages/Public/pages/Login/schema/login";

export type LinkedinTier = "free" | "premium" | "salesNavigator";

/**
 * Resolves a user's LinkedIn account tier from the `hasLiSn` / `hasLinkedinPremium`
 * flags on the user model. Sales Navigator takes precedence over Premium, and the
 * default (neither flag set) is the Free tier.
 */
export const getLinkedinTier = (
	user: Pick<User, "hasLiSn" | "hasLinkedinPremium">
): LinkedinTier => (user.hasLiSn ? "salesNavigator" : user.hasLinkedinPremium ? "premium" : "free");

/** Maps a LinkedIn tier to its translated, user-facing label. */
export const linkedinTierLabel = (tier: LinkedinTier, t: TFunction): string =>
	t(`linkedin.tier.${tier}`);
